module.exports = __webpack_public_path__ + "img/7.a6970a5b.jpg";